import { Dispatch } from 'react';
import { IBreadcrumbs } from '../../../components/molecules/Breadcrumbs';
import getFlagValue, { FLAG_ENUM } from '../../utils/getFlagValue';
import { addQueuePromoCount } from '../../../store/emarsys/action';

interface Props {
  dispatch: Dispatch<any>;
  customerNo: string;
  breadcrumbItems: IBreadcrumbs[];
  pageName: string;
  pageTitle: string;
  sectionName: string;
  buttonName: string;
  newParams?: Record<string, string | number | boolean>;
}

export default function eventClickListingPromo({
  dispatch,
  customerNo,
  breadcrumbItems,
  pageName,
  pageTitle,
  sectionName,
  buttonName,
  newParams,
}: Props) {
  const isFlagActive = getFlagValue('EMARSYS');
  const isFlagPromoListActive = getFlagValue(FLAG_ENUM.EMARSYS_PROMO_LIST);

  if (!isFlagActive || !isFlagPromoListActive) return;

  if (customerNo) {
    ScarabQueue.push(['setCustomerId', customerNo]);
  }

  const valueClickAction: Record<string, string | number | boolean> = {
    page_name: pageName ?? '',
    page_title: pageTitle ?? '',
    page_url: window.location.href,
    section_name: sectionName ?? '',
    button_name: buttonName ?? '',
    menu_cat_lvl1: breadcrumbItems?.[1]?.name?.toLowerCase() || '',
    ...newParams,
  };

  ScarabQueue.push(['tag', 'click_button', valueClickAction]);
  dispatch(addQueuePromoCount());
}
